/*
 * File: index.tsx
 * Desc: 表单单选组件
 * File Created: 2019-10-21 13:45:12
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React from 'react';
import { Form, Radio } from 'antd';
import { FormBaseProps } from '../form-input';
import { FormProps } from 'antd/lib/form';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { RadioChangeEvent } from 'antd/lib/radio';

interface IRadioOption {
    key: string;
    value: string;
}

interface FormRadioProps extends FormBaseProps, Omit<FormProps, 'onChange'> {
    options: IRadioOption[];
    onChange?: (e: RadioChangeEvent) => void;
}

const FormRadio = (props: Partial<HTMLInputElement> & FormRadioProps) => {
    const { label, labelCol, wrapperCol, field, initialValue, required, validator } = props;
    const { getFieldDecorator, getFieldValue } = props.form as WrappedFormUtils;
    return (
        <Form.Item
            {...{
                label,
                labelCol,
                wrapperCol,
            }}
            className={props.className}
            style={props.style}
        >
            {getFieldDecorator(field, {
                initialValue,
                rules: [
                    { required, message: `请选择${label}` },
                    {
                        validator: (rule, value, callback) =>
                            validator ? validator(rule, value, callback) : callback(),
                    },
                ],
            })(
                props.readOnly ? (
                    props.render ? (
                        props.render(getFieldValue(field))
                    ) : (
                        <span>{getFieldValue(field)}</span>
                    )
                ) : (
                    <Radio.Group onChange={props.onChange} disabled={props.disabled}>
                        {props.options.map(option => (
                            <Radio value={option.key}>{option.value}</Radio>
                        ))}
                    </Radio.Group>
                )
            )}
        </Form.Item>
    );
};

export default FormRadio;
